import { defineComponent as _defineComponent } from 'vue';
import { withPrefix } from "@/utils/redirect";
import { useUserStore } from "@/stores/userStore";
import { computed } from "vue";
import WorkflowSearch from "@/components/Workflow/WorkflowSearch.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faUpload, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
// @ts-ignore bad library types
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowBox',
    setup(__props) {
        library.add(faUpload, faGlobe);
        const isAnonymous = computed(() => useUserStore().isAnonymous);
        function userTitle(title) {
            if (isAnonymous.value == true) {
                return `Log in to ${title}`;
            }
            else {
                return title;
            }
        }
        return { __sfc: true, isAnonymous, userTitle, withPrefix, WorkflowSearch, FontAwesomeIcon };
    }
});
